(function () {
  var STORAGE_KEY = 'linger_popup_shown';

  function showPopup() {
    var popup = document.getElementById('linger-popup');
    if (!popup) return;

    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
  }

  function hidePopup() {
    var popup = document.getElementById('linger-popup');
    if (!popup) return;

    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
  }

  function initLingerPopup() {
    var popup = document.getElementById('linger-popup');
    if (!popup) return;

    // Only once per session
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

    // Wait exactly 20s after page is ready
    window.setTimeout(function () {
      // In case DOM changed or user navigated via PJAX etc.
      if (!document.getElementById('linger-popup')) return;

      showPopup();
      sessionStorage.setItem(STORAGE_KEY, '1');
    }, 20000);

    // Close via backdrop or close button
    document.addEventListener('click', function (evt) {
      var target = evt.target;
      if (!target) return;

      if (target.hasAttribute('data-linger-close')) {
        hidePopup();
      }
    });

    // ESC to close
    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') {
        hidePopup();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLingerPopup);
  } else {
    initLingerPopup();
  }
})();